import { Column } from "@/components";

const MAX_LANE_HEIGHT_PX = 12;
const LANE_HEIGHT_RATIO = 0.45;
const CHAIN_PATTERN = `url("data:image/svg+xml,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="12" viewBox="0 0 32 12" fill="none"><rect x="1" y="3" width="18" height="6" rx="3" stroke="#d4e5ef" stroke-width="1.5"/><rect x="17" y="4" width="18" height="4" rx="2" fill="#718a9e" stroke="#b6cedf" stroke-width="1"/><path d="M4 4h12" stroke="#f0f9ff" stroke-opacity=".65"/></svg>',
)}")`;

export const WinterRaceLane = ({
  laneHeightPx,
  progressPercent,
}: {
  laneHeightPx: number;
  progressPercent: number;
}) => {
  /* Render */
  const render = () => {
    return (
      <Column
        className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 rounded-full border-y border-sky-100/70 bg-slate-950/85 shadow-[0_2px_3px_rgba(0,0,0,0.8),0_0_8px_rgba(125,211,252,0.22)]"
        style={{
          height: Math.min(
            MAX_LANE_HEIGHT_PX,
            laneHeightPx * LANE_HEIGHT_RATIO,
          ),
        }}
      >
        <Column
          className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-sky-300/15 via-sky-200/30 to-sky-100/60"
          style={{ width: `${progressPercent}%` }}
        />
        <Column
          className="absolute inset-0 rounded-full bg-[length:2rem_100%] bg-repeat-x"
          style={{ backgroundImage: CHAIN_PATTERN }}
        />
        <Column className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-sky-100/40 via-white/90 to-sky-100/60" />
      </Column>
    );
  };

  return render();
};
